import { create } from "zustand";
import { IDLE_TIMEOUT } from "../constants/Common";

const qcAutoOnlineStore = create((set, get) => ({
  qcAutos: {},  // Lưu trữ bản đồ của từng player
  timeouts: {}, // Lưu timeout của từng player để hủy nếu có cập nhật mới

  setqcAuto: (playerId, newStatus) => {
    if (newStatus != get().qcAutos[playerId]) {
      set((state) => ({
        qcAutos: {
          ...state.qcAutos,
          [playerId]: newStatus,
        },
      }));
    }

    // Nếu đã có timeout, clear nó trước
    if (get().timeouts[playerId]) {
      clearTimeout(get().timeouts[playerId]);
    }

    if (newStatus == true) {
      // Đặt timeout để xóa playerId sau 15 giây nếu không có cập nhật mới
      const timeoutId = setTimeout(() => {
        set((state) => {
          const newStatus = { ...state.qcAutos };
          delete newStatus[playerId];
          return { qcAutos: newStatus };
        });

        // Xóa timeout khỏi danh sách
        set((state) => {
          const newTimeouts = { ...state.timeouts };
          delete newTimeouts[playerId];
          return { timeouts: newTimeouts };
        });
      }, IDLE_TIMEOUT.OFFLINE_STATUS_QC);

      // Cập nhật danh sách timeout
      set((state) => ({
        timeouts: {
          ...state.timeouts,
          [playerId]: timeoutId,
        },
      }));
    }
  },
}));

export default qcAutoOnlineStore;
